<script lang="ts" setup>
/* Types */
/* Utils */
import { cropNumberOfCard } from '@/utils/cropNumberOfCard'

import { SavedCard, TypeCards } from '@/types/api/api-v3/paymentMethods'

type Props = {
  savedCard: SavedCard
}
const props = defineProps<Props>()

const numberCard = computed(() =>
  cropNumberOfCard(props.savedCard.card_number, 4),
)

// Определяем имя бренда (один бренд может быть разными данными)
const brandName = computed(() => {
  /* Виза */
  if (props.savedCard?.brand.includes(TypeCards.VISA)) {
    return TypeCards.VISA
  }

  /* Мастер кард */
  if (props.savedCard?.brand.includes(TypeCards.MASTER_CARD)) {
    return TypeCards.MASTER_CARD
  }

  /* МИР */
  if (props.savedCard?.brand.includes(TypeCards.MIR)) {
    return TypeCards.MIR
  }

  /* Дефолтное */
  return TypeCards.DEFAULT
})

const detectedClassSavedCard = computed(() => {
  // Через тип карты определяем цвет карты
  return [
    'payment-card',
    {
      'payment-card--master': brandName.value === TypeCards.MASTER_CARD,
      'payment-card--mir': brandName.value === TypeCards.MIR,
      'payment-card--visa': brandName.value === TypeCards.VISA,
      'payment-card--default': brandName.value === TypeCards.DEFAULT,
    },
  ]
})

const iconCard = {
  MASTERCARD: 'payments/master-card.png',
  MIR: 'payments/mir.png',
  VISA: 'payments/visa.png',
  DEFAULT: 'payments/default-card.png',
}

// Определяем иконку для карты
const detectedIconOfBrand = computed(() => {
  const nameIcon = brandName.value

  if (iconCard[nameIcon]) {
    return iconCard[nameIcon]
  }

  return iconCard.DEFAULT
})
</script>

<template>
  <div :class="detectedClassSavedCard">
    <nuxt-img
      class="payment-card__icon"
      :src="detectedIconOfBrand"
      :alt="savedCard.brand"
    />

    <div class="payment-card__number-card">
      {{ '&bull;&bull;&bull;' }} {{ numberCard }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.payment-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding: 5px;
  color: var(--ui-text-primary);
  cursor: pointer;
  background: #f8fafc;
  border-radius: 6px;

  @include media('>tablet') {
    min-height: unset;
  }

  &__number-card {
    font-size: 12px;
    font-weight: 600;
    line-height: 14px;
  }

  &--default {
    color: var(--ui-white);
    background: linear-gradient(90deg, #3c2e97 0%, #6b5bd0 100%) !important;

    .payment-card__icon {
      width: 24px;
      height: 24px;
    }
  }

  &--master {
    color: var(--ui-white);
    background: linear-gradient(
      269.42deg,
      #635e5e 0.38%,
      #343434 99.38%
    ) !important;

    .payment-card__icon {
      width: 31px;
      height: 19px;
      margin: 2px 0 0 4px;
    }
  }

  &--mir {
    color: var(--ui-white);
    background: linear-gradient(
      269.42deg,
      #1bbf22 0.38%,
      #00960f 99.38%
    ) !important;

    .payment-card__icon {
      width: 38px;
      height: 10px;
      margin-top: 6px;
    }
  }
  &--visa {
    color: var(--ui-white);
    background: linear-gradient(
      269.42deg,
      #347ed5 0.38%,
      #225fa6 99.38%
    ) !important;

    .payment-card__icon {
      width: 38px;
      height: 12px;
      margin-top: 5px;
    }
  }
}
</style>
